import { Reveal } from "../lib/reveal";
import { TrendingUp, Workflow, Users, Compass } from "lucide-react";

const services = [
  {
    icon: TrendingUp,
    title: "Growth strategy",
    body: "Win better clients and higher-value work. We build a pipeline and positioning that fits how built-environment practices actually sell.",
    span: "lg:col-span-7 lg:row-span-2",
    image: "https://images.pexels.com/photos/13886489/pexels-photo-13886489.jpeg",
  },
  {
    icon: Workflow,
    title: "Process efficiency",
    body: "Cut the drag out of delivery — from bid to sign-off — with lean workflows and the right tooling.",
    span: "lg:col-span-5",
  },
  {
    icon: Compass,
    title: "Fractional leadership",
    body: "Senior guidance on tap, without a full-time hire on the books.",
    span: "lg:col-span-5",
  },
  {
    icon: Users,
    title: "Team & capability",
    body: "Structure, roles and skills that let your practice scale without breaking the culture that makes it good.",
    span: "lg:col-span-12",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="px-5 md:px-10 max-w-[1400px] mx-auto py-24 md:py-32">
    <Reveal>
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-4">02 / What we do</p>
      <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-none max-w-3xl">
        Two levers. Grow the practice, or make it run better.
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-4 auto-rows-[minmax(180px,auto)]">
      {services.map((s, i) => {
        const Icon = s.icon;
        return (
          <Reveal key={s.title} delay={i * 0.08} className={s.span}>
            <div
              data-testid={`service-card-${i}`}
              className="group relative h-full bg-card border border-border p-8 md:p-10 overflow-hidden hover:border-primary transition-colors duration-300"
            >
              {s.image && (
                <div className="absolute inset-0 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-[0.08] group-hover:opacity-[0.16] group-hover:scale-105 transition-[opacity,transform] duration-500"
                  />
                </div>
              )}
              <div className="relative z-10 flex flex-col h-full">
                <Icon className="text-primary" size={28} strokeWidth={1.6} />
                <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight mt-auto pt-10">
                  {s.title}
                </h3>
                <p className="text-muted-foreground mt-3 max-w-md leading-relaxed">{s.body}</p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
